<template>
  <v-card class="mt-1" flat>
    <v-card-text class="pb-0">
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap>
          <v-flex md4 sm3>
            <v-select :label="messages.label.PACKAGE_ID" chips tags append-icon="" clearable
              :error-messages="packageIdErrorMessages" required v-model="packageIds"
              :hint="messages.info.PACKAGE_ID_HELP_TEXT" persistent-hint class="mt-2">
              <template slot="selection" slot-scope="data">
                <v-chip close :color="!isValidPackageId(data.item) ? 'red' : ''"
                  :text-color="!isValidPackageId(data.item) ? 'white' : ''" @input="removePackageId(data.item)"
                  :selected="data.selected">
                  <strong>{{ data.item }}</strong>
                </v-chip>
              </template>
            </v-select>
          </v-flex>
          <v-flex md2 sm3>
            <v-text-field :label="messages.label.PROVIDER_NAME" v-model="providerName"></v-text-field>
          </v-flex>
          <v-flex md2 sm3>
            <v-text-field :label="messages.label.AFFILIATE_NAME" v-model="affiliateName">
            </v-text-field>
          </v-flex>
          <v-flex md2 sm3>
            <v-menu ref="rightsWindowMenu" lazy :close-on-content-click="false" v-model="rightsWindowMenu"
              transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px">
              <v-text-field slot="activator" :label="messages.label.RIGHTS_WINDOW" v-model="rightsWindow"
                prepend-icon="event" readonly></v-text-field>
              <v-date-picker v-model="rightsWindow" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="clearRightsWindow()">{{ messages.label.CANCEL }}</v-btn>
                <v-btn flat color="primary" @click="$refs.rightsWindowMenu.save(endDate)">{{ messages.label.OK }}</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md2 class="text-xs-right">
            <v-btn color="primary" @click="searchOffers">{{ messages.label.SEARCH }}</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment"
import PreIngestService from "@/PreIngest/PreIngestService"
import messages from "@/PreIngest/messages.json"

export default {
  name: "OffersSearchFilter",
  data() {
    return {
      packageIds: [],
      providerName: "",
      affiliateName: "",
      rightsWindow: null,
      rightsWindowMenu: false,
      forcePackageIdValidation: false
    }
  },
  methods: {
    /**
     * removePackageId - description
     *
     * @param  {type} item description
     * @return {type}      description
     */
    removePackageId(item) {
      this.packageIds.splice(this.packageIds.indexOf(item), 1)
      this.packageIds = [...this.packageIds]
    },

    /**
     * isValidPackageId - description
     *
     * @param  {type} value description
     * @return {type}       description
     */
    isValidPackageId(value) {
      let assetIdRegEx = new RegExp("^[a-zA-Z]{4}[0-9]{16}$")
      let rtnValue = assetIdRegEx.test(value)

      return rtnValue
    },

    /**
     * clearRightsWindow - description
     *
     * @return {type}  description
     */
    clearRightsWindow() {
      this.rightsWindow = null
    },

    /**
     * getUnixTimeStamp - description
     *
     * @param  {type} date description
     * @return {type}      description
     */
    getUnixTimeStamp(date) {
      let dateFormat = "YYYY-MM-DD"
      let unixTimeStamp = ""
      if (!this.$lodash.isNull(date)) {
        unixTimeStamp = moment(date, dateFormat).unix() * 1000
      }

      return unixTimeStamp
    },

    /**
     * searchOffers - description
     *
     * @return {type}  description
     */
    searchOffers() {
      this.forcePackageIdValidation = true
      if (this.packageIdErrorMessages.length !== 0) {
        return false
      }

      // TODO: Add once 'byStartDate' is available
      // byStartDate: this.getUnixTimeStamp(this.rightsWindow)
      let searchQueryObject = {
        byProviderName: this.providerName,
        byAffiliate: this.affiliateName,
        byAssetReference: ""
      }
      // Pass package Ids if entered
      if (this.packageIds.length > 0) {
        searchQueryObject.byAssetReference = this.packageIds.join("|")
      }

      let filteredSearchObject = this.$lodash.reduce(
        searchQueryObject,
        (result, value, key) => {
          if (value !== null && value.length > 0) {
            result[key] = value
          }
          return result
        },
        {}
      )
      PreIngestService.$emit("event:searchOffers", filteredSearchObject)
    }
  },
  computed: {
    /**
     * Returns error messages to be displayed if Package ID is invalid
     */
    packageIdErrorMessages() {
      let errors = []
      let validPackageIds = this.packageIds.filter(this.isValidPackageId)
      if (this.forceAssetIdValidation) {
        if (this.packageIds.length === 0 || validPackageIds.length === 0) {
          errors.push(this.messages.validation.VALID_PACKAGE_ID_REQUIRED)
        } else {
          errors = []
          this.forcePackageIdValidation = false
        }
      } else if (this.packageIds.length > 0 && validPackageIds.length === 0) {
        errors.push(this.messages.validation.VALID_PACKAGE_ID_REQUIRED)
      }

      return errors
    }
  },
  created() {
    this.messages = messages
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/PreIngest/Offers/OffersSearchFilter.vue